import isempty from 'lodash/isEmpty';

import EdapActions from '../actions/edapActions';
import RequestToBookModalActions from '../actions/requestToBookModalActions';
import TripActions from '../actions/tripActions';
import ListingActions from '../actions/listingActions';
import ListingPageActions from '../actions/listingPageActions';
import {OpenModalStates} from '../records/listingPageRecord';
import {getPricingInfoFromState} from './utils/getPricingInfoFromState';
import {
    getMaxAdultsFromHouseRules,
    getMaxChildrenFromHouseRules,
    hasValidGuestCount,
    hasValidPets
} from '../utils/guests';
import {getInquiryLoginUrl} from '../utils/universalLogin';

/*
    state: {
        listingReducer: {
            propertyOlb: true
            pricingInfo: (get){<listingID: {checkoutError: '', checkoutUrl: ''}}
        },
        tripDetailsReducer: {
            adults: 1,
            arriveDateText: '',
            departDateText: ''
        },
        listingPageReducer: {
            validDates: {datesValid: true}
        }
    }
}
*/

function getBookingUrl(state) {
    const pricingInfo = getPricingInfoFromState(state);
    return pricingInfo.checkoutUrl || null;
}

function hasCheckoutObjNoError(state) {
    const listingObjJs = getPricingInfoFromState(state);
    const checkoutError = listingObjJs.checkoutError;

    return !isempty(listingObjJs) && !checkoutError;
}

function pricingReadyForCheckout(state) {
    const isAvailable = hasCheckoutObjNoError(state);
    const bookingUrl = getBookingUrl(state);

    return isAvailable && !!bookingUrl;
}

function invalidGuests(state) {
    const {
        tripDetailsReducer: {adults, children, hasPets},
        listingReducer: {houseRules, sleeps, petsAllowed}
    } = state;

    const maxAdults = getMaxAdultsFromHouseRules({houseRules, sleeps});
    const maxChildren = getMaxChildrenFromHouseRules({houseRules, sleeps});
    const validGuests = hasValidGuestCount({
        adults,
        children,
        maxAdults,
        maxChildren,
        sleeps,
        isEmptyValid: false
    });
    const validPets = hasValidPets({hasPets, petsAllowed});

    return !validGuests || !validPets || !adults;
}

function invalidDates(state) {
    const {datesValid} = state.listingPageReducer.validDates;
    return !datesValid;
}

/* eslint-disable complexity */
function primaryCTAClicked(store, action = {payload: {}}) {
    const state = store.getState();
    const {listingReducer, travelerFeaturesReducer} = state;
    const {actionLocation} = action.payload;
    const loggedIn = travelerFeaturesReducer.isLoggedIn;

    const readyForCheckout = pricingReadyForCheckout(state);
    const promptDateChanges = invalidDates(state);
    const promptGuestChanges = invalidGuests(state);

    if (listingReducer.onlineBookable) {
        store.dispatch(EdapActions.triggerEdapListingBooknowClick(actionLocation));
        store.dispatch(EdapActions.triggerEdapCheckoutSelected());
        if (readyForCheckout && !promptDateChanges && !promptGuestChanges) {
            store.dispatch(RequestToBookModalActions.requestToBookModalSubmit());
        } else if (promptDateChanges) {
            store.dispatch(TripActions.setBookingFlow(true));
            store.dispatch(
                ListingPageActions.setShowDatePickerModalDesktop(
                    actionLocation === 'sticky booking panel'
                )
            );
            store.dispatch(ListingActions.openDatePickerModal());
        } else if (promptGuestChanges) {
            store.dispatch(TripActions.setBookingFlow(true));
            store.dispatch(ListingActions.openGuestSelectorModal());
        } else {
            store.dispatch(ListingActions.setRequestToBookModalOpen(true));
        }
    } else {
        if (!loggedIn) {
            const universalLoginUrl = getInquiryLoginUrl(window.location.href, {
                r: OpenModalStates.INQUIRY
            });
            window.location.assign(universalLoginUrl);
            return;
        }

        store.dispatch(ListingActions.setInquiryModalOpen(true));

        store.dispatch(
            EdapActions.triggerEdapEvent('generic.modal', {
                modalname: 'inquiry',
                modalaction: 'open'
            })
        );
    }
}
/* eslint-enable complexity */

export default primaryCTAClicked;
export {primaryCTAClicked};
